<template>
  <v-container>
    <h1>Innstillinger for {{ organization.name }}</h1>

    <v-card class="orange lighten-5 mt-5" elevation="3">
      <v-form ref="form" lazy-validation @submit.prevent="submit">
        <v-card-title class="white--text orange"
          >Rediger innstillinger</v-card-title
        >

        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="organization.name"
                label="Firmanavn"
                :disabled="isSaving"
                hint="Navn på firma registrert i Brønnøysund."
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="organization.organization_number"
                label="Organisasjonsnummer"
                :disabled="isSaving"
                hint="Organisasjonsnummer i Brønnøysund. Husk MVA etter tallet dersom registrert i momsregisteret."
                persistent-hint
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="organization.vat_enabled"
                label="Registrert i momsregisteret"
                :disabled="isSaving"
                class="mt-0"
              ></v-checkbox>
              <p>
                Når dette er skrudd på vil moms automatisk kalkuleres basert på
                momsklasser satt på produktene i din butikk.
                <br />
                Husk at prisen du oppgir på produkter og leveringsmetoder
                <b>alltid er inklusive moms!</b>
              </p>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="organization.terms"
                label="Vilkår"
                :disabled="isSaving"
                hint="Salgsvilkår som blir vist i butikken og som kunde må godta for å gjennomføre bestilling."
                persistent-hint
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-btn type="submit" color="success" :loading="isSaving">
            <v-icon left> mdi-content-save </v-icon>
            Lagre
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";

export default {
  name: "AdminOrganizationSettings",

  data: function () {
    return {
      organization: {},
      isSaving: false,
    };
  },

  computed: {
    organizationId() {
      return this.$store.state.auth.organization.id;
    },
  },

  async created() {
    this.organization = await backend.get(
      `organizations/${this.organizationId}/`
    );
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.organization = await backend.put(
          `organizations/${this.organization.id}/`,
          {
            name: this.organization.name,
            vat_enabled: this.organization.vat_enabled,
            terms: this.organization.terms,
            organization_number: this.organization.organization_number,
          }
        );

        this.$store.dispatch("add", {
          type: "success",
          message: "Innstillingene har nå blitt lagret.",
        });
      }
    },
  },
};
</script>
